import React from 'react';
import { useField } from 'formik';
import { IFormikFieldProps } from './FormikFieldProps';
import { FormCheck, FormCheckProps } from 'react-bootstrap';

export type CheckboxProps = IFormikFieldProps &
  React.InputHTMLAttributes<HTMLInputElement> &
  FormCheckProps;

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const [field, { value, touched, error }] = useField(props);

  return (
    <FormCheck
      type="checkbox"
      isInvalid={touched && !!error}
      checked={value}
      {...field}
      {...props}
    />
  );
};
